import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {initReducerContext} from '@someok/simple-reducer-store';
import extraNewsActions from './actions';

const initialState = {
    id: null,
    appId: null,
    newsById: {},
    currentTmpId: null,
    tmpIds: [],

    // 以 tmpId 为 key 用于记录 zip 包中的 html 列表
    // 格式为：{[tmpId]: {id, paths}}
    entrypointsById: {},

    // 表单是否修改
    dirty: false,
};

const [useExtraNewsStore, ExtraNewsStoreProvider, ExtraNewsContext] = initReducerContext(
    initialState,
    extraNewsActions
);

export {useExtraNewsStore, ExtraNewsStoreProvider, ExtraNewsContext};

const ExtraNewsWrapper = ({children, initialValues}) => {
    const [, dispatch] = useExtraNewsStore();
    // console.log('initialValues', initialValues);

    useEffect(() => {
        dispatch(['initNews', initialValues]);
    }, [dispatch, initialValues]);

    return <>{children}</>;
};

ExtraNewsWrapper.propTypes = {
    children: PropTypes.node,
    initialValues: PropTypes.object,
};

export default ExtraNewsWrapper;
